import React from 'react';

import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';

import { Container, CustomerRegister } from '@ttstr/components';

const Register: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  function handleRegistered() {
    history.push('/customer/registered');
  }

  return (
    <article className="my-5 customer-page">
      <Container>
        <Helmet>
          <title>{t(`REGISTER.TITLE`)}</title>
        </Helmet>
        <h1 className="text-center mb-4">{t(`REGISTER.TITLE`)}</h1>
        <Row>
          <Col lg={{ size: 6, offset: 3 }}>
            <p className="text-center">
              <strong>{t('REGISTER.SUBTITLE')}</strong>
            </p>
            <p className="text-justify">{t('REGISTER.DESCRIPTION')}</p>
            <CustomerRegister onRegistered={handleRegistered} />
          </Col>
        </Row>
      </Container>
    </article>
  );
};

export default React.memo(Register);
